<template>
    <div class="userCenter_right">
        <div class="title_div">
            <span class="title_left">应用列表</span>
        </div>
        <div class="title_input">
            <div class="title_input_left">
                <el-input
                    placeholder="请输入应用名称"
                    size="medium"
                    v-model="softwareName">
                    <i slot="suffix" class="el-input__icon el-icon-search" @click="getList"></i>
                </el-input>
            </div>
        </div>
        <div class="tableContent" style="padding: 0 18px 20px;">
            <el-table
                ref="singleTable"
                :data="tableData"
                border
                el-table-column
                style="width: 100%">
                <el-table-column
                    label="序号"
                    type="index"
                    header-align="center"
                    align="center"
                    width="50">
                </el-table-column>
                <el-table-column
                    property="softwareName"
                    sortable
                    show-overflow-tooltip
                    label="应用名称">
                </el-table-column>
                <el-table-column
                    property="softwareModelName"
                    show-overflow-tooltip
                    label="规格名称">
                </el-table-column>
                <!--<el-table-column-->
                    <!--property="stateName"-->
                    <!--sortable-->
                    <!--label="状态"-->
                    <!--width="100"-->
                    <!--:filters="[{ text: '未运行', value: '未运行' }, { text: '运行中', value: '运行中' }, { text: '快过期', value: '快过期 ' }, { text: '过期', value: '过期' }   ]"-->
                    <!--:filter-method="filterTag"-->
                    <!--filter-placement="bottom-end">-->
                    <!--<template slot-scope="scope">-->
                        <!--<el-tag v-if="scope.row.stateName === '未运行'"-->
                                <!--type="info"-->
                                <!--disable-transitions>{{scope.row.stateName}}-->
                        <!--</el-tag>-->
                        <!--<el-tag v-if="scope.row.stateName === '运行中'"-->
                                <!--type="success"-->
                                <!--disable-transitions>{{scope.row.stateName}}-->
                        <!--</el-tag>-->
                        <!--<el-tag v-if="scope.row.stateName === '快过期'"-->
                                <!--type="warning"-->
                                <!--disable-transitions>{{scope.row.stateName}}-->
                        <!--</el-tag>-->
                        <!--<el-tag v-if="scope.row.stateName === '过期'"-->
                                <!--type="danger"-->
                                <!--disable-transitions>{{scope.row.stateName}}-->
                        <!--</el-tag>-->

                    <!--</template>-->

                <!--</el-table-column>-->
                <el-table-column
                    property="userName"
                    label="创建人"
                    show-overflow-tooltip
                    width="80">
                </el-table-column>
                <el-table-column
                    width="150"
                    property="validityStartDate"
                    label="有效期开始时间">
                </el-table-column>
                <el-table-column
                    width="150"
                    property="validityEndDate"
                    sortable
                    label="有效期结束时间">
                </el-table-column><!--
                <el-table-column
                    fixed="right"
                    label="操作"
                    width="100">
                    <template slot-scope="scope">
                        <el-button type="text" size="small">查看</el-button>
                        <el-button type="text" size="small">编辑</el-button>
                    </template>
                </el-table-column>-->
            </el-table>
            <div style="margin-top: 10px;text-align: right">
                <el-pagination
                        background
                        @current-change="handleCurrentChange"
                        @prev-click="handleCurrentChange"
                        @next-click="handleCurrentChange"
                        layout="total,prev, pager, next,jumper"
                        :page-size="pageSize"
                        :total="total"
                        class="pagination">
                </el-pagination>
            </div>
        </div>
    </div>
</template>

<script>
    import {querySoftwareOrderDetailList} from "../../../utils/interface";
    import {mapMutations} from "vuex";

    export default {
        name: "index",
        data() {
            return {
                //   分页
                pageNo: 1,
                total: 100,
                pageSize: 5,
                softwareName: '',
                formLabelWidth: '120px',
                dialogFormVisible: false,
                tableData: [],
                currentRow: null
            }
        },
        mounted() {
            this.init();
        },
        methods: {
            init() {
                this.softwareName ='';
                this.pageNo = 1;
                this.getList();
            },
            getList() {
                this.loading = true
                let params = {
                    softwareName: this.softwareName,
                    current: this.pageNo,
                    pageSize: this.pageSize,
                    isBuy: true,
                    state: 2000,
                };
                querySoftwareOrderDetailList(params).then((res) => {
                    this.tableData = res.list;
                    this.total = res.total;
                    // console.log(this.modelOrderList);
                    this.loading = false
                });
            },
            handleCurrentChange(val) {
                this.currentRow = val;
				window.scrollTo(0,0);
            },
            filterTag(value, row) {
                return row.stateName === value;
            },
        }
    }
</script>
<style scoped lang="less">
    .title_input {
        padding: 20px 18px;
        display: flex;
        justify-content: space-between;
        align-items: center;
    }
    .tableContent {
        /deep/ .el-table .el-table__cell {
            padding: 5px 0;
        }
    }
    .title_input_left {
        width: 300px;

        .el-input__icon {
            cursor: pointer;

            &:hover {
                color: #009999;
            }
        }
    }

    .title_input_right {
    }

    .userCenter_right {
        width: 966px;
        background: #fff;

        h4 {
            color: #009999;
            padding: 20px 18px;
            border-bottom: 2px solid #f9f9f9;
        }

        .title_div {
            padding: 20px 18px;
            border-bottom: 2px solid #f9f9f9;
        }

        .title_left {
            font-weight: bold;
            color: #009999;
        }

        .title_right {
            float: right;
            margin-right: 30px;
        }

        .userCenter_right_box {
            padding: 30px 18px;

            .formItem {
                display: flex;
                margin-bottom: 30px;
                position: relative;

                .title {
                    width: 150px;
                    line-height: 40px;
                    letter-spacing: 1px;
                    color: #494a4c;
                }

                .inputClass {
                    width: 70%;
                }
            }

            .buttonGroupClass {
                text-align: right;

                button {
                    padding: 8px 12px;
                    background-color: #009999;
                    border-color: #009999;

                    &:hover {
                        background-color: #4a96f1;
                        border-color: #4a96f1;
                    }

                    i {
                        padding-right: 5px;
                        font-size: 14px;
                    }
                }
            }
        }
    }
    /deep/.el-pagination.is-background .el-pager li:not(.disabled).active {
        background-color: #009999;
    }
</style>



// WEBPACK FOOTER //
// src/components/registeredLogin/softwareApplication/index.vue